<script lang="ts" setup>
import { useAttrs } from 'vue'
import { Label, type LabelProps } from 'radix-vue'
import { useFormField } from './useFormField'
import { cn } from '../../../lib/utils'

defineOptions({
  inheritAttrs: false,
})
const props = defineProps<LabelProps>()

const { formItemId } = useFormField()
const { class: className, ...rest } = useAttrs()
</script>

<template>
  <Label
    :class="cn(
      `justify-center items-start inline-flex text-[color:var(--theme-heading-color)] text-sm font-semibold gap-4`,
      className ?? '',
    )"
    :as="props.as"
    :for="props.as == 'div' ? undefined : props.for || formItemId"
    v-bind="rest"
  >
    <slot />
  </Label>
</template>

<style scoped>
@import '../../../assets/css/mixins/_mixins.index.pcss';

label {
  @mixin body-small;
}
</style>
